<template>
  <div :style="pathsStyle">
    <div class="box-head">Importance of Allosteric pathways</div>

    <div class="box-tool">
      <a style="cursor:pointer" @click="downloadTxt">{{task.id}}-paths.txt</a> <a v-if="plotReady" style="cursor:pointer" @click="downloadPng">{{task.id}}-paths.png</a>
    </div>

    <div v-if="!showPlot">
      <el-button type="text" @click.native="viewPlot">View Pathway Importance</el-button>
    </div>

    <div v-if="showPlot && !plotReady">
      Loading <i class="el-icon-loading"></i>
    </div>

    <div v-show="showPlot" style="overflow-y:auto;padding:5px">
      <div :style="canvasStyle">
        <canvas ref="canvas" id="paths-bar"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import interpolate from 'color-interpolate'
import Chart from 'chart.js'
import { saveAs } from 'file-saver'

export default {
  name: 'Paths',

  data () {
    return {
      showPlot: false,
      plotReady: false,
      active_site: [],
      allosteric_site: [],
      pathsStyle: {
        margin: '20px 0px',
        position: 'relative',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-ms-user-select': 'none'
      },
      canvasStyle: {
        width: '100%',
        height: '500px'
      }
    }
  },

  props: [ 'value' ],

  computed: {
    task () {
      return this.$store.state.task
    }
  },

  methods: {
    viewPlot () {
      this.showPlot = true
      this.checkTask()
    },

    downloadPng () {
      let v = this
      let url = v.$refs.canvas.toDataURL('image/jpg')
      saveAs(url, `${v.task.id}-paths.png`)
    },

    downloadTxt () {
      let v = this
      let lines = []
      if (v.labels && v.labels.length) {
        lines = v.labels.map((label, i) => `${i} ${v.weights[i]} ${label}`)
      } else if (v.task && v.task.results && v.task.results.paths) {
        let grouped = {}
        for (let path of v.task.results.paths) {
          let filtered = path.path.filter(i => {
            let j = parseInt(i)
            return !(v.active_site.includes(j)) && !(v.allosteric_site.includes(j))
          })
          let id = filtered.join('-')
          if (!(id in grouped)) grouped[id] = { weight: 0.0 }
          grouped[id].weight += path.weight
        }
        let ids = Object.keys(grouped).sort((a, b) => grouped[b].weight - grouped[a].weight)
        let ind = v.task.results.ind || []
        for (let i = 0; i < Math.min(ids.length, 100); i++) {
          let name = ids[i].split(/-/).map(j => {
            let r = ind.find(k => k.num === parseInt(j))
            return r ? r.name : ''
          }).join(' - ')
          lines.push(`${i} ${grouped[ids[i]].weight} Start - ${name} - End`)
        }
      }
      let content = lines.join('\n')
      var blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
      saveAs(blob, `${v.task.id}-paths.txt`)
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

    getInd (chainName, resNum) {
      for (let i of this.task.results.ind) {
//        console.log(JSON.stringify(i))
//        console.log(`${chainName}/${resNum}`)
        if (`${chainName}/${resNum}` === i.name) {
          return i.num
        }
      }
      return -1
//      return this.task.results.ind.find(i => i.name === `${chainName}/${resNum}`).num
    },

    getSites (sites) {
      let vec = []
      let ls = sites.trim().split(/,/)
      for (let s of ls) {
        let w = s.split(/\//)
        let chainName = w[0]
        let residues = w[1]
        let v = residues.split(/\+/)
        for (let i of v) {
          let u = i.split(/-/)
          if (u.length === 2) {
            let a = parseInt(u[0])
            let b = parseInt(u[1])
            for (let j = a; j <= b; j++) {
              vec.push(this.getInd(chainName, j))
            }
          } else if (u.length === 1) {
            vec.push(this.getInd(chainName, u[0]))
          }
        }
      }
      return vec
    },

    checkTask () {
      let v = this
      let task = this.task

      if (task) {
        v.active_site = v.getSites(task.par.active_site)
        v.allosteric_site = v.getSites(task.par.allosteric_site)
        let paths = {}
        for (let path of v.task.results.paths) {
          let id = path.path.filter(i => {
            let j = parseInt(i)
            return !(v.active_site.includes(j)) && !(v.allosteric_site.includes(j))
          }).join('-')
          if (!(id in paths)) {
            paths[id] = {
              weight: 0.0
            }
          }
          paths[id].weight += path.weight
        }

        let maxWeight = 0.0
        console.log(v.task.results.ind)
        for (let id in paths) {
          paths[id].name = `Start - ${id.split(/-/).map(i => {
            let find_result = v.task.results.ind.find(j => j.num === parseInt(i))
            return find_result ? find_result.name : ""
          }).join(' - ')} - End`
          if (maxWeight < paths[id].weight) {
            maxWeight = paths[id].weight
          }
        }
        for (let id in paths) {
          paths[id].normWeight = paths[id].weight / maxWeight
        }

        let ids = Object.keys(paths)
        ids.sort((a, b) => paths[b].weight - paths[a].weight)

        let colormap = interpolate(['#053795', 'green', 'yellow', '#900c3f'])
        let data = []
        let labels = []
        let colors = []
        let nPath = 0
        for (let id of ids) {
          if (nPath < 100) {
            data.push(paths[id].weight)
            labels.push(paths[id].name)
            colors.push(colormap(paths[id].normWeight))
            nPath += 1
          }
        }
//        console.log(data)

//        console.log(Object.keys(labels).length)
        v.canvasStyle.height = `${Object.keys(labels).length * 15}px`

        v.weights = data
        v.labels = labels

        let barChart = new Chart(document.getElementById('paths-bar').getContext('2d'), {
          type: 'horizontalBar',
          data: {
            labels: labels,
            datasets: [{
              label: 'Path',
              data: data,
              backgroundColor: colors,
              borderColor: colors,
              borderWidth: 1
            }]
          },
          options: {
//            responsive: true,
            maintainAspectRatio: false,

            legend: {
              display: false
            },

            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }],

              xAxes: [
                { position: 'top' }
              ]
            }
          }
        })
//        console.log(barChart)

        this.plotReady = true
      } else {
        setTimeout(() => {
          v.checkTask()
        }, 500)
      }
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}

.box-tool {
  padding:10px 0px;
}

</style>
